import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Slider } from "@components/atoms/Slider"
import { brandVariants } from "@utils/brand-variants"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, SlotBlocks } from "eddev/blocks"
import { AnimatePresence, motion, MotionProps } from "motion/react"

export const meta: BlockMeta = {
  title: "Featured Card",
  category: "layouts",
  icon: "slides",
  description: "A featured card with media content",
  keywords: ["category", "genre", "tile"],
  tags: ["#homepage", "#featured"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

const fadeVariants: MotionProps = {
  variants: {
    hide: { opacity: 0 },
    show: { opacity: 1 },
  },
}

export default defineBlock("content/featured-card", (props) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial="hide"
        animate="show"
        exit="hide"
        className="mx-auto w-grid grid grid-cols-1 md:grid-cols-3"
        transition={{ staggerChildren: 0.05 }}
        data-mixpanel-block="Featured Card"
      >
        <div
          className={cn(
            brandVariants({ theme: props.theme || undefined }),
            "order-2 md:order-1 flex type-title-l md:h-[12em] p-5",
          )}
        >
          <div className="flex flex-col h-full justify-between w-full">
            <div className="flex flex-col gap-3 w-full">
              <motion.div className="type-title-l" {...fadeVariants}>
                <EditableText store="title" as="div" defaultValue="Enter a title" plainText />
              </motion.div>

              <motion.div className="flex flex-col gap-3 type-body-s" {...fadeVariants}>
                <SlotBlocks
                  id="description"
                  title="Description"
                  allowedBlocks={["core/paragraph"]}
                  adminClassName="flex flex-col gap-3"
                  template={[["core/paragraph", { placeholder: "Enter body text" }]]}
                  orientation="vertical"
                />
              </motion.div>
            </div>

            <motion.div className="w-full flex flex-col gap-1 type-body-s" {...fadeVariants}>
              <SlotBlocks
                id="buttons"
                title="Buttons"
                allowedBlocks={["content/featured-card-button"]}
                adminClassName="flex flex-col gap-1"
                template={[
                  ["content/featured-card-button", {}],
                  ["content/featured-card-button", {}],
                  ["content/featured-card-button", {}],
                ]}
                orientation="vertical"
              />
            </motion.div>
          </div>
        </div>
        <motion.div className="order-1 md:order-2 col-span-2 md:h-full relative" {...fadeVariants}>
          {props.image ? (
            <ResponsiveImage
              {...props.image}
              className="w-full md:h-full md:absolute md:left-0 md:top-0"
              objectFit="cover"
              objectPosition="center"
            />
          ) : env.admin ? (
            <div className="w-full h-full bg-grey flex justify-center items-center">IMAGE</div>
          ) : null}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
})
